import script from "./CompanyLandscape.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLandscape.vue?vue&type=script&setup=true&lang=js"

import "./CompanyLandscape.vue?vue&type=style&index=0&id=e794e07c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e794e07c"]])

export default __exports__